import React from 'react';
import { ReactComponent as IconDelete } from "@assets/Icons/IconDelete_KE.svg";
import { ReactComponent as IconEdit } from "@assets/Icons/IconEdit_KE.svg";
import { Auth0Customer } from './CustomersData';


interface ActionsIconsProps {
  row: Auth0Customer;
  onEdit: (userId: string) => void;
  onDelete: (userId: string) => void;
}

export const ActionsIcons: React.FC<ActionsIconsProps> = ({ row, onEdit, onDelete }) => {
  return (
    <div className="flex gap-5">
      <IconEdit
        onClick={() => onEdit(row.user_id)}
        className="
        border border-semantic-border-secondary
        rounded text-semantic-text-secondary
        cursor-pointer
        w-5 h-5"
      />
      <IconDelete
        onClick={() => onDelete(row.user_id)}
        className="
            border border-semantic-border-secondary
            rounded text-semantic-text-secondary
            cursor-pointer
            w-5 h-5"
      />
    </div>
  );
};
